import { gql } from "graphql-request";

const SERVER_UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation SERVER_UpdateDocumentTemplate($id: ID!, $input: DocumentTemplateInput!) {
    updateDocumentTemplate(id: $id, input: $input) {
      id
    }
  }
`;
export default SERVER_UPDATE_DOCUMENT_TEMPLATE;